/**
* Images Gallery JS
* -----------------------------------------------------------------------------
*
* All the JS for the Images Gallery component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {Draggable} from 'gsap/Draggable.js';
import {InertiaPlugin} from 'gsap/InertiaPlugin';
// import {Draggable, Handler, Rotatable} from 'momentum.js';
( function( app ) {
  const COMPONENT = {

    className: 'images-gallery',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( Draggable, InertiaPlugin );
      $( '.images-gallery .image-wrapper' ).each( function( key, image ) {
        const containerWidth = $( image ).closest( '.inner-area' ).outerWidth() - $( image ).width();
        const containerHeight = $( image ).closest( '.inner-area' ).outerHeight() - $( image ).height();
        const top = ( Math.floor( Math.random() * ( containerHeight - 0 + 1 ) + 0 ) );
        const left = ( Math.floor( Math.random() * ( containerWidth - 0 + 1 ) + 0 ) );
        const deg = ( Math.floor( Math.random() * ( 30 - ( -30 ) + 1 ) + ( -30 ) ) );

        if ( window.innerWidth > 1024 ) {
          $( image ).css( {
            top: top,
            left: left,
            transform: 'rotate(' + deg + 'deg)',
          } );

          Draggable.create( image, {
            type: 'x,y',
            edgeResistance: 0.65,
            bounds: $( image ).closest( '.inner-area' )[0],
            inertia: true,
            onPress: function() {
              $( image ).addClass( 'is-active' );
            },
            onRelease: function() {
              $( image ).removeClass( 'is-active' );
            },
          } );
        } else {
          $( image ).css( {
            transform: 'rotate(' + deg + 'deg)',
          } );
        }
      } );

      $( '.images-gallery' ).each( function( key, val ) {
        if ( window.innerWidth > 1024 ) {
          Draggable.create( $( val ).find( '.click-drag' )[0], {
            type: 'x,y',
            edgeResistance: 0.25,
            bounds: $( val ).find( '.inner-area' )[0],
            inertia: true,
            onPress: function() {
              $( val ).find( '.click-drag' ).addClass( 'is-active' );
            },
            onRelease: function() {
              $( val ).find( '.click-drag' ).removeClass( 'is-active' );
            },
          } );
        } else {
          $( val ).find( '.inner-area' ).slick( {
            dots: false,
            arrows: false,
          } );

          $( val ).find( '.prev-slide' ).on( 'click', function() {
            $( val ).find( '.inner-area' ).slick( 'slickPrev' );
          } );

          $( val ).find( '.next-slide' ).on( 'click', function() {
            $( val ).find( '.inner-area' ).slick( 'slickNext' );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'images-gallery', COMPONENT );
} )( app );
